import { HTMLAttributes } from "react"

export default function Graphql(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.89626 36.3195L5.17126 35.3231L24.39 2.03775L26.1139 3.03375L6.89626 36.3195Z"
        fill="#E434AA"
      />
      <path
        d="M4.77527 32.6644H43.2113V34.6556H4.77527V32.6644Z"
        fill="#E434AA"
      />
      <path
        d="M24.7616 44.883L5.53723 33.7837L6.53323 32.058L25.758 43.1587L24.7616 44.883ZM41.4622 15.9536L22.2379 4.85287L23.2339 3.129L42.4586 14.2279L41.4622 15.9536Z"
        fill="#E434AA"
      />
      <path
        d="M6.53776 15.9461L5.54138 14.2207L24.7676 3.1215L25.7636 4.84575L6.53776 15.9461Z"
        fill="#E434AA"
      />
      <path
        d="M41.1079 36.3195L21.8906 3.03375L23.6149 2.03775L42.8336 35.3231L41.1079 36.3195ZM6.29999 12.8993H8.29236V35.1007H6.30036L6.29999 12.8993Z"
        fill="#E434AA"
      />
      <path
        d="M39.7076 12.8993H41.6996V35.1007H39.7076V12.8993Z"
        fill="#E434AA"
      />
      <path
        d="M24.4234 44.0404L23.5534 42.5329L40.2732 32.8785L41.1432 34.386L24.4234 44.0404Z"
        fill="#E434AA"
      />
      <path
        d="M44.3393 35.748C43.188 37.752 40.62 38.436 38.6164 37.2848C36.6124 36.132 35.9284 33.564 37.0796 31.56C38.2324 29.556 40.8004 28.872 42.8044 30.0236C44.82 31.188 45.504 33.744 44.3393 35.748ZM10.9088 16.44C9.75601 18.444 7.18801 19.128 5.18401 17.9764C3.18001 16.8236 2.49601 14.256 3.64763 12.252C4.80038 10.248 7.36801 9.564 9.37201 10.7152C11.376 11.88 12.06 14.436 10.9088 16.44ZM3.66076 35.748C2.50763 33.744 3.19201 31.188 5.19563 30.0232C7.19963 28.872 9.75563 29.556 10.9204 31.56C12.0716 33.564 11.3876 36.12 9.38363 37.2848C7.36801 38.436 4.81201 37.752 3.66076 35.748ZM37.0913 16.44C35.94 14.436 36.624 11.88 38.628 10.7152C40.632 9.564 43.188 10.248 44.3524 12.252C45.5036 14.256 44.82 16.812 42.816 17.9767C40.812 19.128 38.244 18.444 37.0913 16.44ZM24 47.496C23.4499 47.4965 22.9051 47.3885 22.3967 47.1782C21.8884 46.9679 21.4265 46.6595 21.0375 46.2705C20.6486 45.8815 20.3401 45.4196 20.1298 44.9113C19.9195 44.4029 19.8115 43.8581 19.812 43.308C19.8115 42.7579 19.9195 42.2131 20.1298 41.7047C20.3401 41.1964 20.6486 40.7345 21.0375 40.3455C21.4265 39.9565 21.8884 39.6481 22.3967 39.4378C22.9051 39.2275 23.4499 39.1195 24 39.12C24.5501 39.1195 25.0949 39.2275 25.6033 39.4378C26.1116 39.6481 26.5735 39.9565 26.9625 40.3455C27.3515 40.7345 27.6599 41.1964 27.8702 41.7047C28.0805 42.2131 28.1885 42.7579 28.188 43.308C28.188 45.6124 26.316 47.496 24 47.496ZM24 8.88C23.4499 8.88049 22.9051 8.7725 22.3967 8.56221C21.8884 8.35192 21.4265 8.04345 21.0375 7.65446C20.6486 7.26547 20.3401 6.8036 20.1298 6.29526C19.9195 5.78693 19.8115 5.24211 19.812 4.692C19.8115 4.14189 19.9195 3.59707 20.1298 3.08874C20.3401 2.5804 20.6486 2.11853 21.0375 1.72954C21.4265 1.34055 21.8884 1.03208 22.3967 0.821787C22.9051 0.611495 23.4499 0.503506 24 0.503999C24.5501 0.503506 25.0949 0.611495 25.6033 0.821787C26.1116 1.03208 26.5735 1.34055 26.9625 1.72954C27.3515 2.11853 27.6599 2.5804 27.8702 3.08874C28.0805 3.59707 28.1885 4.14189 28.188 4.692C28.1885 5.24211 28.0805 5.78693 27.8702 6.29526C27.6599 6.8036 27.3515 7.26547 26.9625 7.65446C26.5735 8.04345 26.1116 8.35192 25.6033 8.56221C25.0949 8.7725 24.5501 8.88049 24 8.88Z"
        fill="#E434AA"
      />
    </svg>
  )
}
